// The browser refuses the clipboard on an unfocused document, without permission, and over plain
// HTTP anywhere but localhost — where it offers no `clipboard` at all. None of that is worth
// interrupting the reader over: the value they asked for is on screen beside the control.
export async function copyToClipboard(text: string): Promise<void> {
  try {
    await navigator.clipboard?.writeText(text);
  } catch {
    return;
  }
}
